module.exports = __webpack_public_path__ + "media/src/assets/icons/ico-login-28c2986dd1d655fde32a0beb34d25408.svg";